import React from 'react'
import { Switch, Route } from 'react-router'
import loadable from '@loadable/component'

import { LANGUAGES } from '../_i18n/languages'
import parseTimerFromPath from '../timer/parseTimerFromPath'

const Terms = loadable(() => import('../terms/Terms'))
const Privacy = loadable(() => import('../privacy/Privacy'))
const NotFound = loadable(() => import('../notFound/NotFound'))
const Stopwatch = loadable(() => import('../stopwatch/Stopwatch'))
const Timer = loadable(() => import('../timer/Timer'))
const Focus = loadable(() => import('../focus/Focus'))

const MultiLanguageRoute = (props) => {
    const matchObj = props.computedMatch || props.match || { params: {} };
    const firstParam = matchObj.params.lang || 'en';
    const is404Page = props.location.pathname.split('/')[3];
    const servicePath = props.location.pathname.split('/')[1];
    const staticContext = props.staticContext;

    if (is404Page) return <Route render={() => <NotFound staticContext={staticContext} />} />;

    // Caso 1: Idioma oficial reconhecido (ex: /pt, /pt/timer-5-minutos, /en/timer-5-minutes)
    if (LANGUAGES[firstParam]) {
        if (servicePath && servicePath.length === 2) {
            let ptfp = parseTimerFromPath(props);
            if ((typeof ptfp === 'boolean') && (!ptfp)) {
                return <Route render={() => <NotFound staticContext={staticContext} />} />;
            }
        }
        return <Route {...props} />;
    }

    // Caso 2: Preset de timer direto na raiz sem prefixo de idioma (ex: /timer-5-minutes, /5-minutes-timer)
    const ptfp = parseTimerFromPath(props);
    if (ptfp && typeof ptfp !== 'boolean') {
        return <Route {...props} component={Timer} />;
    }

    return <Route render={() => <NotFound staticContext={staticContext} />} />;
};

const router = (props) => (
    <React.Fragment>
        <Switch>
            <Route exact path='/' component={Timer} />
            <Route path='/terms' component={Terms} />
            <Route path='/privacy' component={Privacy} />
            <MultiLanguageRoute path='/focus/:lang?' {...props} component={Focus} />
            <MultiLanguageRoute path='/stopwatch/:lang?' {...props} component={Stopwatch} />
            <MultiLanguageRoute path='/:lang/:param?' {...props} component={Timer} />
            <Route {...props} component={NotFound} />
        </Switch>
    </React.Fragment>
);

export default router;